<template>
  <div>
    <div class="main">
      <router-view></router-view>
    </div>
    <vue-snotify></vue-snotify>

    <div class="footer">
      <div class="container">Версия 2.1</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import Datepicker from 'vuejs-datepicker';
import Snotify, { SnotifyPosition } from 'vue-snotify/vue-snotify.min';
import 'pace-js/themes/blue/pace-theme-flash.css';
import Pace from 'pace-js';
import VueCookies from 'vue-cookies';
import VueTheMask from 'vue-the-mask';
import router from './router/index-client';
import store from './store/index';

Vue.component('my-component', {
  components: {
    Datepicker,
  },
});

Vue.router = router;
Vue.use(VueCookies);
Vue.use(VueAxios, axios);
Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightBottom,
    showProgressBar: true,
    titleMaxLength: 50,
    timeout: 5000,
  },
});
Vue.use(VueTheMask);

Vue.axios.defaults.headers.common = {
  'X-CSRFToken': VueCookies.get('csrftoken'),
};

export default {
  name: 'app',
  data() {
    return {
      dataReady: false,
    };
  },
  store,
  created() {
    Pace.start({
      ajax: { trackWebSockets: false },
      restartOnRequestAfter: true,
    });
  },
};
</script>

<style lang="scss">
  @import "sass/main";
  @import "./assets/css/material-kit.css";
  @import "~vue-snotify/styles/material";

  .page-header {
    min-height: 400px !important;
    height: 400px !important;
  }

  .main-raised {
    margin-top: -250px !important;
    min-height: 600px;
  }

  .vertical-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .footer .container {
    font-size:80%;
    opacity:0.5;
  }
</style>
